var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{style:({ width: _vm.width }),attrs:{"tile":_vm.$vuetify.breakpoint.xs,"flat":_vm.$vuetify.breakpoint.xs}},[(!_vm.noTitle)?_c('v-toolbar',{attrs:{"dark":"","color":"primary","flat":""}},[_c('v-spacer'),_c('v-toolbar-title',[_vm._t("title")],2),_c('v-spacer')],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }